import { useState, useEffect } from 'react';
import { usePrevious } from 'hooks';

export const useLoading = ({ orderId, loading, onDataLoad }) => {
  const [loaded, setLoaded] = useState(undefined);

  const previousLoading = usePrevious(loading);

  useEffect(() => {
    if (onDataLoad && loaded) onDataLoad();
  }, [loaded, onDataLoad]);

  useEffect(() => {
    if (previousLoading === loading) return;
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLoaded(previousLoading && !loading);
  }, [loading, previousLoading]);

  return {
    showSpinner: orderId && loading,
  };
};
